import moment from "moment";

export const paymentPerMonth = (payments) =>
  payments.map((payment) => payment.monthlyPayment)[0];

export const formatDate = (date) => moment(date).format("DD.MM.YYYY");

export const formatPaymentPeriod = (date, roundDate) =>
    `с ${formatDate(date)} по ${formatDate(roundDate)}`;

export const transformPaymentNumbers = (payments) =>
  payments?.map((payment) =>
    Object.fromEntries(
      Object.entries(payment).map(([key, value]) => [
        key,
        typeof value === "number" ? value.toFixed(2) : value,
      ])
    )
  );
